module.exports = __webpack_public_path__ + "static/handshake-9b55bb0cd99e1447aacb78b352d40a31.svg";